@if ({ expanded: toggleService.expanded$ | async }; as context) {
    @if (meeting) {
        <div class="meeting-switcher-toggle-container" (click)="toggleSwitcher(context.expanded ?? false)">
            <div class="greyhounds-event-info">
                <div [msWhenOverflowed]="{ classNameToAdd: 'too-long' }">{{ meeting.name }}</div>
            </div>
            <span class="sports-icon theme-right" [class.disabled]="!isEnabled" [class.expanded]="context.expanded"></span>
        </div>
    }
}
